;(function() {

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP or ScrollTrigger is missing');
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // ==================================================
    // 1. EFFET DE SUPERPOSITION (Pin de l'intro)
    // ==================================================
    const introSection = document.querySelector('.o-home-introduction');
    const firstVideoSection = document.querySelector('.o-section-video');

    if (introSection && firstVideoSection) {
        ScrollTrigger.create({
            trigger: introSection,
            start: 'top 10%',
            endTrigger: firstVideoSection,
            end: 'top top',
            pin: true,
            pinSpacing: false,
        });
    }

    // ==================================================
    // 2. LOGIQUE DES SECTIONS VIDEO
    // ==================================================
    const videoSections = document.querySelectorAll('.o-section-video');

    if (!videoSections.length) return;

    const mobileMedia = window.matchMedia('(max-width: 767px)');

    videoSections.forEach((section) => {
        const container = section.querySelector('.o-section-video__container');
        const preview = section.querySelector('.o-section-video__preview');
        const videoElement = preview ? preview.querySelector('video') : null;
        const label = section.querySelector('.o-section-video__label');
        const isFullwidth = section.classList.contains('o-section-video--fullwidth');

        const getSource = (desktopUrl, mobileUrl) => {
            if (mobileMedia.matches && mobileUrl) {
                return mobileUrl;
            }

            return desktopUrl || mobileUrl || '';
        };

        const updatePreviewSource = () => {
            if (!videoElement || section.classList.contains('is-playing')) return;

            const previewUrl = getSource(
                videoElement.dataset.previewUrl,
                videoElement.dataset.previewMobileUrl
            );

            if (previewUrl && videoElement.currentSrc !== previewUrl && videoElement.src !== previewUrl) {
                videoElement.src = previewUrl;
                videoElement.load();
                videoElement.play().catch(() => {});
            }
        };

        updatePreviewSource();

        if (mobileMedia.addEventListener) {
            mobileMedia.addEventListener('change', updatePreviewSource);
        } else if (mobileMedia.addListener) {
            mobileMedia.addListener(updatePreviewSource);
        }
        
        // --- A. ANIMATION AU SCROLL (GROW / CLIP-PATH) ---
        const initialInset = 'inset(10vh 15vw)'; 
        const finalInset = 'inset(0vh 0vw)';

        if(container && !isFullwidth) {
            gsap.fromTo(container, 
                { clipPath: initialInset },
                {
                    clipPath: finalInset,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: 'top bottom', 
                        end: 'top top',      
                        scrub: 0.5,          
                    }
                }
            );
        }

        if(videoElement && !isFullwidth) {
            gsap.fromTo(videoElement,
                { scale: 1.1 },
                { 
                    scale: 1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: 'top bottom',
                        end: 'top top',
                        scrub: true
                    }
                }
            );
        }
        

        // --- B. GESTION DU CLICK ---
        if (preview && videoElement && preview.classList.contains('js-video-preview')) {
            preview.addEventListener('click', function() {
                if (section.classList.contains('is-playing')) return;

                const fullUrl = getSource(this.dataset.videoUrl, this.dataset.videoMobileUrl);

                if (!fullUrl) return;

                if (label) {
                    gsap.to(label, { autoAlpha: 0, duration: 0.3 });
                }

                videoElement.src = fullUrl;   
                videoElement.muted = false;   
                videoElement.controls = true; 
                videoElement.loop = false;    
                
                const playPromise = videoElement.play();
                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                        section.classList.add('is-playing');
                    }).catch(error => {
                        console.error('Erreur lecture:', error);
                    });
                }
            });
        }
    });

})();
